export const APP_API_ENDPOINT = "https://schoolportal.uac.edu.au/api";